import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: ", ";\n  width: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: visible;\n\n  & + & {\n    margin-left: ", ";\n    margin-top: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color } from '@scp/ui-shared/theme/variables';
import { getCSSUnitValue, baselineToRem } from '@scp/ui-shared/theme/utils';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_SUFFIX = '-store-link';
var PROPS_TO_OMIT = ['isVertical'];
var HEIGHT_RATIO = 0.2927;
export var getHeightByRatio = function getHeightByRatio(itemWidth) {
  if (typeof itemWidth === 'number') {
    return "".concat(itemWidth * HEIGHT_RATIO, "px");
  }

  var _ref = itemWidth.split(/(\d+(?:\.\d+)?)/).filter(Boolean) || [],
      _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      units = _ref2[1];

  var height = parseFloat(value) * HEIGHT_RATIO;
  return "".concat(height).concat(units);
};
var Wrapper = styled.div(_templateObject(), function (props) {
  return props.isVertical ? 'column' : 'row';
});
var StoreLink = styled(withRippleEffect('a')).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !PROPS_TO_OMIT.includes(prop);
  }
}).attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})(_templateObject2(), function (props) {
  return props.isVertical ? 0 : baselineToRem(4);
}, function (props) {
  return props.isVertical ? baselineToRem(3) : 0;
});
var IconWithoutProps = withoutProps(Icon, ['itemWidth']);
var StoreIcon = styled(IconWithoutProps).attrs({
  size: 'auto',
  color: color.palette.black
})(_templateObject3(), function (props) {
  return getHeightByRatio(props.itemWidth);
}, function (props) {
  return getCSSUnitValue(props.itemWidth);
});
/**
 * An app store link component.
 *
 * Can show either apple or google store links and both.
 *
 * @example ./__docs__/AppStoreLinks.md
 */

export function AppStoreLinks(_ref3) {
  var _ref3$itemWidth = _ref3.itemWidth,
      itemWidth = _ref3$itemWidth === void 0 ? baselineToRem(21) : _ref3$itemWidth,
      appleLink = _ref3.appleLink,
      appleLinkAriaLabel = _ref3.appleLinkAriaLabel,
      googleLink = _ref3.googleLink,
      googleLinkAriaLabel = _ref3.googleLinkAriaLabel,
      _ref3$isVertical = _ref3.isVertical,
      isVertical = _ref3$isVertical === void 0 ? false : _ref3$isVertical;
  return React.createElement(Wrapper, {
    isVertical: isVertical
  }, appleLink && React.createElement(StoreLink, {
    href: appleLink,
    "aria-label": appleLinkAriaLabel,
    isVertical: isVertical,
    "data-e2e": getE2eLabel('apple', E2E_SUFFIX)
  }, React.createElement(StoreIcon, {
    name: "apple-store",
    itemWidth: itemWidth
  })), googleLink && React.createElement(StoreLink, {
    href: googleLink,
    "aria-label": googleLinkAriaLabel,
    isVertical: isVertical,
    "data-e2e": getE2eLabel('google', E2E_SUFFIX)
  }, React.createElement(StoreIcon, {
    name: "google-store",
    itemWidth: itemWidth
  })));
}